export default {
  'txt-board': 'Priceboards',
  'txt-trade': 'Trading',
  'txt-market-analysis': 'Market Analysis',
  'txt-trade-acronym': 'Order',
  'txt-cash-transfer': 'Cash Transfer',
  'txt-asset': 'Asset',
  'txt-total-asset': 'Total Asset',
  'txt-cash-advance': 'Cash Advance',
  'txt-stock-transfer': 'Stock Internal Transfer',
  'txt-money-transfer': 'Cash Internal Transfer',
  'txt-margin-debt': 'Margin debt',
  'txt-deposit-withdrawal': 'Deposit / Withdrawn Money',
  'txt-reference-subcription': 'Rights Info',
  'txt-hold-unhold': 'Hold / unhold bank',

  'txt-order': 'Order',
  'txt-rate': 'Rate',
  'txt-login': 'Login',
  'txt-xacthuc': 'Authenticate',
  'txt-cancel': 'Cancel',
  'txt-re-login': 'Re-login',
  'txt-order-confirm': 'Confirm Order',
  'txt-ignore': 'Ignore',
  'txt-detail': 'Detail',
  'txt-move': 'Move',
  'txt-moved': 'Moved',
  'txt-registration': 'Registration',
  'txt-accept': 'Accept',
  'txt-clear': 'Clear',
  'txt-regis-bank-account': 'Register bank account',
  'txt-change': 'Change',
  'txt-change-per': '% Change',
  'txt-change-pass': 'Change Password',
  'txt-change-account': 'Change Account',
  'txt-change-login-account': 'Change Login Account',
  'txt-register': 'Register',
  'txt-btn-order-cond': 'Order Condition',

  'txt-day': 'days',
  'txt-coso': 'Equities',
  'txt-phaisinh': 'Derivatives',
  'txt-notice': 'Notifications',
  'txt-search': 'Search',
  'txt-add-symbol': 'Add Symbol',
  'txt-da-xacthuc': 'Authenticated',
  'txt-chua-xacthuc': 'Not authentic',
  'txt-sub-account': 'Sub Account',
  'txt-normal': 'Normal',
  'txt-utilities': 'Utilities',
  'txt-contact': 'Contact',
  'txt-guide': 'Guide',
  'txt-sign-out': 'Sign Out',
  'txt-update': 'Update',
  'txt-nav': 'NAV',
  'txt-stock-val': 'Stock value',
  'txt-pp': 'PP',
  'txt-pp-margin': 'Account Topup PP',
  'txt-cashbalance': 'Cash balance',
  'txt-wdrawAvail': 'Withdraw available',
  'txt-advanceAvail': 'Advance available',
  'txt-stock-waiting': 'Stock waiting',
  'txt-collateral': 'Collateral',
  'txt-debt': 'Debt',
  'txt-depoFee': 'Deposit Fee',
  'txt-total-depoFee': 'Total Deposit Fee',
  'txt-margin-limit': 'Margin limit',
  'txt-buy-max': 'Buy max',
  'txt-sell-max': 'Sell max',
  'txt-margin-rate': 'Margin rate',

  'txt-cw': 'Covered Warrants',
  'txt-tp': 'Bonds',
  'txt-cs': 'Equities',
  'txt-ps': 'Derivatives',
  'txt-pt': 'Put Through',
  'txt-market': 'Market',
  'txt-symbol-name': 'Title',

  'txt-portfolio': 'Positions',
  'txt-balance': 'Balance',

  'txt-symbol': 'Symbol',
  'txt-stock': 'Symbol',
  'txt-info': 'Info',
  'txt-max-margin-rate': 'Max margin rate',
  'txt-ref': 'Ref',
  'txt-ceil': 'Ceil',
  'txt-floor': 'Floor',
  'txt-bid': 'Bid',
  'txt-ask': 'Ask',
  'txt-price': 'Price',
  'txt-stick-size': 'Tick size',
  'txt-vol': 'Vol',
  'txt-origin-vol': 'Original Vol',
  'txt-match': 'Matched',
  'txt-total-vol': 'T.Vol',
  'txt-oi': 'OI',
  'txt-total-val': 'T.Val',
  'txt-high': 'High',
  'txt-low': 'Low',
  'txt-ave': 'Avg',
  'txt-price-ave': 'Avg Price',
  'txt-price-close': 'Close Price',
  'txt-price-open': 'Open Price',
  'txt-total-num': 'Total',
  'txt-foreign': 'Foreign',
  'txt-buy': 'Buy',
  'txt-sell': 'Sell',
  'txt-order-no': 'Order No.',
  'txt-origin-order-no': 'Origin Order No.',
  'txt-type': 'Type',
  // 'txt-price': 'Price',
  'txt-price-order': 'Price Order',
  'txt-match-vol': 'Matched Vol',
  'txt-match-price': 'Matched Price',
  'txt-cancel-vol': 'Canceled Vol',
  'txt-total-match-value': 'T.Matched Value',
  'txt-status': 'Status',
  'txt-actions': 'Actions',
  'txt-market-price': 'MP',
  'txt-gain-loss': 'Gain/Loss',
  'txt-orders': 'Orders',
  'txt-help': 'Help',
  'txt-to': 'to',
  'txt-add-to': 'Add to',
  'txt-vol-buy': 'Buy Vol.',
  'txt-vol-sell': 'Sell Vol.',
  'txt-total-match-vol': 'T.Match Vol.',
  'txt-total-match-val': 'T.Match Val.',
  'txt-lowest': 'Lowest',
  'txt-highest': 'Highest',

  'txt-order-normal': 'Normal Order',
  'txt-order-margin': 'Margin Order',
  'txt-order-cond': 'Conditional Order',

  'txt-stt': 'No.',
  'txt-time': 'Time',
  'txt-giatri': 'Value',

  'txt-login-account': "Login Thien Viet Securities's account",
  'txt-account': 'Account',
  'txt-account-acronym': 'Acc',
  'txt-account-number': 'Account number',
  'txt-pass': 'Password',
  'txt-all': 'All',
  'txt-closed': 'Closed',
  'txt-opened': 'Open',
  'txt-intermission': 'Intermission',
  'txt-preopen': 'ATO',
  'txt-atc': 'ATC',
  'txt-c': 'Put Through',
  'txt-plo': 'PLO',
  'txt-offline': 'Offline',

  'txt-reserved': 'Reserved',
  'txt-sent': 'Sent',
  'txt-confirm': 'Confirm',
  'txt-matched': 'Matched',
  'txt-part-matched': 'Match Partial',
  'txt-canceled': 'Canceled',
  'txt-pending': 'Pending',
  'txt-transfer-pending': 'Pending',
  'txt-complete': 'Complete',
  'txt-bank-error': 'Bank error',
  'txt-admended': 'Admended',
  'txt-rejected': 'Rejected',
  'txt-error-order': 'Error Order',
  'txt-expired': 'Expired',

  'txt-success': 'Success',
  'txt-unsuccessful': 'Unsuccessful',

  'txt-match-order-vol': 'Match order vol',
  'txt-match-one-time': 'Match one time',
  'txt-out-time': 'Order out time',
  'txt-trend-order': 'Trend Order',
  'txt-take-profit': 'Take profit order',
  'txt-stop-loss': 'Stop loss order',
  'txt-purchase-order': 'Purchase order',
  'txt-transfer-content': 'Deposit money into stock account',

  'txt-cond-pending': 'Pending',
  'txt-cond-active': 'Active',
  'txt-cond-activated': 'Activated',
  'txt-cond-final': 'Close',
  'txt-cond-expired': 'Expired',
  'txt-cond-cancelling': 'Cancelling',
  'txt-cond-wait-react': 'Wait for reactivation',
  'txt-cond-effective-time': 'Effective time',
  'txt-cond-setting-condition': 'Setting condition',
  'txt-cond-setting-price': 'Setting price',
  'txt-cond-method-trend': 'Method of determining the trend',
  'txt-cond-pause-value': 'Pause in value',
  'txt-cond-pause-per': 'Pause in %',
  'txt-cond-choose-price': 'Choose price',
  'txt-cond-diff-price': 'Price difference TP',
  'txt-cond-lowest-price': 'Lowest purchase price',
  'txt-cond-highest-price': 'Highest purchase price',
  'txt-cond-activation-conditions': 'Activation-conditions',
  'txt-cond-avg': 'Avg price',
  'txt-cond-diff-for-avg': 'Price difference Avg',
  'txt-cond-diff-for-avg-per': 'Value difference',
  'txt-cond-diff-for-cur-price': 'Price difference Current price',
  'txt-cond-total-cond': 'Summary of activation conditions',

  'txt-open-account': 'Open account »',
  'txt-forgot-pass': 'Forgot password?',
  'txt-no-data-found': 'No data found!',
  'txt-no-add-catalog': 'Do not add stock to category ',
  'txt-symbol-has-in-catalog': 'The stock has been in category: ',
  'txt-price-not-match': 'Price not match',
  'txt-vol-not-match': 'Volume not match',
  'txt-cash-not-match': 'Cash not match',
  'txt-no-beneficiary-data': 'No beneficiary data',
  'txt-symbol-not-match': 'Symbol not match',
  'txt-price-not-over': 'Price should not over ceil price',
  'txt-price-not-less': 'Price should not less than floor price: ',
  'txt-hsx-price': 'HSX no pricing MTL/MOK/MAK/PLO',
  'txt-hnx-price': 'HNX no pricing MP',
  'txt-upcom-price': 'UPCOM no pricing market price',
  'txt-valid-time': 'Time invalid',
  'txt-valid-range-time': 'Reports are only allowed within ',
  'txt-valid-5-catalog': 'Add max 15 category in watchlist',
  'txt-valid-exist-category': 'Already exists ',
  'txt-valid-not-del': 'Not delete ',
  'txt-valid-not-edit': 'Not edit ',
  'txt-valid-excess-amount':
    'The amount is in excess of the transferable amount',
  'txt-valid-max-amount': 'Max amount',
  'txt-valid-min-amount': 'Min amount',
  'txt-valid-send-otp': 'Do not send more than 05 OTPs within 2 minutes',
  'txt-valid-same-pass': 'New password and old password are the same',
  'txt-valid-pass-confirm-not-match':
    'New password and confirm password do not match',
  'txt-valid-input-required': 'Input required',
  'txt-valid-characters': 'characters',
  'txt-valid-enter': 'Enter',
  'txt-valid-phone-incorrect-format':
    'Your phone number is not in the correct format',
  'txt-valid-date-incorrect-format':
    'Your date of birth is not in the correct format',
  'txt-valid-email-incorrect-format': 'Email invalidate',
  'txt-valid-enter-verification-code': 'Please enter the verification code',
  'txt-valid-loss-session': 'Lost session. You need to re-login to continue.',
  'txt-valid-old-account-not-match':
    'Old account is not the same Login account',
  'txt-valid-same-new-account': 'New account and Old account overlap',

  'txt-show': 'Show',
  'text-order': 'orders',
  'txt-overview': 'Overview (B VND)',
  'txt-all-market': 'All market',
  'txt-total-transaction': 'Total Transaction',
  'txt-total-putThrough': 'Total Put Through',
  'txt-total-foreign': 'Foreign',
  'txt-international': 'International',

  'txt-orderNo': 'Order No.',
  'txt-lost-connect': 'Lost connect',
  'txt-regis-unsuccessful': 'Register private unsuccessful',

  'txt-title-order-cond': 'Condition Order',
  'txt-title-authentication-success': 'Authentication successful',
  'txt-title-neworder-success': 'New order success',
  'txt-title-neworder-unsuccess': 'New order fail',
  'txt-title-delorder-success': 'Cancel order success',
  'txt-title-editorder-success': 'Edit order success',
  'txt-title-hold-success': 'Hold/Unhold bank success!',
  'txt-title-asset-manage': 'Asset management',
  'txt-title-debt-manage': 'Debt management',
  'txt-title-transfer-stock-fail': 'Stock transfer fail',
  'txt-title-transfer-success': 'Stock transfer success',
  'txt-title-login-success': 'Login success',
  'txt-title-changepass-success':
    'Password changed successfully. You need to re-login to continue',
  'txt-title-max': 'Max',
  'txt-title-min': 'Min',
  'txt-title-withdrawal-confirmation': 'Withdrawal confirmation',
  'txt-title-withdrawal-verification': 'Withdrawal verification',
  'txt-title-edit-confirm': 'Confirm order modification',
  'txt-title-new-confirm': 'Confirm new order',
  'txt-title-delete-confirm': 'Confirm delete order',
  'txt-title-fill-info-regis':
    'Fill out the information you registered with Thien Viet Securities',
  'txt-title-login-no-cif': 'No Account Information',

  'txt-stt-in-date': 'In due date',
  'txt-stt-due-date': 'Due date',
  'txt-stt-out-date': 'Out of date',
  'txt-stt-right-cash': 'Right cash',
  'txt-stt-right-buy': 'Right buy',
  'txt-stt-right-stock': 'Right stock',
  'txt-stt-internal': 'Internal',
  'txt-stt-bank': 'Bank',

  'txt-stt-right-01': 'Cash Dividend',
  'txt-stt-right-02': 'Stock Dividend',
  'txt-stt-right-03': 'Paid-in Capital Increase',
  'txt-stt-right-04': 'Bonus Issue',
  'txt-stt-right-05': 'Paid Capital Reduction',
  'txt-stt-right-06': 'Capital Reduction',
  'txt-stt-right-07': 'Merge',
  'txt-stt-right-08': 'Spin-Off',
  'txt-stt-right-09': 'Symbol Change',
  'txt-stt-right-11': 'Stock Split',
  'txt-stt-right-12': 'Reverse Stock Split',

  'txt-asset-total': 'Total Assets',
  'txt-asset-nav': 'Net Asset Value',
  'txt-asset-withdraw': 'Withdrawable Amount',
  'txt-asset-receivable': 'Available adv. amount',
  'txt-asset-withdrawal': 'Withdrawable Amount',
  'txt-asset-receivable-1': 'Available adv. amount',
  'txt-asset-balance': 'Account balance',
  'txt-asset-actual-balance-account': 'Actual balance on account',
  'txt-asset-cash-balance': 'Money available',
  'txt-asset-receivable-amount': 'Receivable Amount',
  'txt-asset-buy-mount': 'Secure Amount',
  'txt-asset-unmatch-amount': 'Blocked Amount',
  'txt-asset-collateral': 'Collateral',
  'txt-asset-collateral-stock': 'Stock Dividends',
  'txt-asset-stocks': 'Stocks',
  'txt-asset-market-stocks': 'Market Value of stocks',
  'txt-asset-guaranteed': 'Value of assets to be guaranteed',
  'txt-asset-outstanding-debt': 'Outstanding Debt',
  'txt-asset-adding': 'Adding amount',
  'txt-asset-remain-margin': 'Remain margin amount',
  'txt-asset-day-loan': 'Margin loan in day',
  'txt-asset-principal': 'Principal Margin',
  'txt-asset-month-depo-fee': 'Total Deposit Fee',
  'txt-asset-other-fee': 'Fee SMS',
  'txt-asset-cash-can-transfer': 'Cash can transfer',
  'txt-asset-margin-loan-interest': 'Margin loan interest',

  'txt-label-cash': 'Cash',
  'txt-label-avail': 'Avail',
  'txt-label-position': 'Position',
  'txt-label-page': 'Page',
  'txt-label-from': 'From',
  'txt-label-to': 'To',
  'txt-label-right': 'Right',
  'txt-label-total-loan': 'Total loans',
  'txt-label-loan-date': 'Loan date',
  'txt-label-expire-date': 'Expire date',
  'txt-label-expired-date': 'Expire date',
  'txt-label-interest': 'Interest',
  'txt-label-fee': 'Fee',
  'txt-label-tax': 'Tax',
  'txt-label-free': 'Free',
  'txt-label-defer-interest': 'Deferred interest',
  'txt-label-repay-interest': 'Repay Interest',
  'txt-label-remain-interest': 'Debt remain',
  'txt-label-disbursement-date': 'Disbursement date',
  'txt-label-maturity-date': 'Maturity date',
  'txt-label-interest-rate': 'Interest rate',
  'txt-label-loan-amount': 'Loan amount',
  'txt-label-penalty-delay': 'Penalty',
  'txt-label-paid': 'Paid',
  'txt-label-unpaid': 'Unpaid',
  'txt-label-repay': 'Repaid',
  'txt-label-unrepay': 'Unrepay',
  'txt-label-in-due-amount': 'In due amount',
  'txt-label-pay': 'Pay',
  'txt-label-total-amount': 'Total amount',
  'txt-label-real-amount': 'Real amt',
  'txt-label-payment-history': 'Payment history',
  'txt-label-return-asset': 'Return Assets',
  'txt-label-major': 'Major',
  'txt-label-opening-balance': 'Opening balance',
  'txt-label-closing-balance': 'Closing balance',
  'txt-label-increase': 'Increase',
  'txt-label-decrease': 'Decrease',
  'txt-label-vol-up': 'Vol up',
  'txt-label-vol-down': 'Vol down',
  'txt-label-remark': 'Remark',
  'txt-label-overview': 'Overview',
  'txt-label-history-price': 'Trading Data',
  'txt-label-finance': 'Financials',
  'txt-label-events': 'Events',
  'txt-label-news': 'News',
  'txt-label-documents': 'Profile',
  'txt-label-details': 'Details',
  'txt-label-amount': 'Amount',
  'txt-label-expected-date': 'Expected exercise date',
  'txt-label-registration-date': 'Registration date',
  'txt-label-quantity-record-date': 'Quantity at record date',
  'txt-label-ratio': 'Ratio',
  'txt-label-pending-transfer': 'Pending Transfer',
  'txt-label-pending-delivery': 'Waiting Delivery',
  'txt-label-pending-trading': 'Waiting Trade',
  'txt-label-tran-date': 'Transaction date',
  'txt-label-tran-amount': 'Amount',
  'txt-label-tran-type': 'Type',
  'txt-label-deposit': 'Deposit',
  'txt-label-withdrawal': 'Withdrawal',
  'txt-label-hold-bank': 'Hold in bank',
  'txt-label-withdrawal-bank': 'Withdrawal from bank',
  'txt-label-bank-link': "Bank's link",
  'txt-label-bank-name': "Bank's name",
  'txt-label-branch-name': "Branch's name",
  'txt-label-bank-account': 'Bank account no.',
  'txt-label-bank-hold-amount': 'Hold amount',
  'txt-label-history': 'History',
  'txt-label-transfer-to': 'Transfer to',
  'txt-label-source': 'Source',
  'txt-label-target': 'Target',
  'txt-label-create-date': 'Create date',
  'txt-label-stock-transfer': 'Stock transfer',
  'txt-label-stock-holding': 'Stock holding',
  'txt-label-vol-holding': 'Volume holding',
  'txt-label-cash-transfer-amount': 'Amount',
  'txt-label-cash-transfer-content': 'Content',
  'txt-label-internal-transfer': 'Cash transaction order',
  'txt-label-online-transfer': 'transfer online from',
  'txt-label-right-subscription': 'Right subscription',
  'txt-label-max-subscription': 'Maximum amount subscription: ',
  'txt-label-owned-quantity': 'Quantity at record date',
  'txt-label-remaining-quantity': 'Remaining quantity for buying	',
  'txt-label-purchased-quantity': 'Purchased quantity	',
  'txt-label-maximum-quantity': 'Maximum quantity for buying',
  'txt-label-start-date': 'Start date',
  'txt-label-end-date': 'End date',
  'txt-label-base-date': 'Base date',
  'txt-label-market-value': 'Market value',
  'txt-label-buy-amt': 'Buy amount',
  'txt-label-billion': 'B',
  'txt-label-deposit-stock': 'Deposit money into stock account',
  'txt-label-beneficiary': 'Beneficiary',
  'txt-label-account-beneficiary': 'Beneficiary Account',
  'txt-label-choose': 'Choose',
  'txt-label-transfer-content': 'Transfer content',
  'txt-label-amount-want-transfer': 'Amount want to transfer',
  'txt-label-source-advance': 'Source Advance',
  'txt-label-amount-advance': 'Amount Advance',
  'txt-label-advance-request': 'Request advance',
  'txt-label-amount-deducted': 'Amount deducted',
  'txt-label-fee-service': 'Service fee',
  'txt-label-fee-management': 'Management fee',
  'txt-label-total': 'Total',
  'txt-label-sell-date': 'Sell date',
  'txt-label-trade-amount-af-fee': 'Trade amount after fee',
  'txt-label-settlement-date': 'Settlement date',
  'txt-label-calculator-fee': 'Calculate Fee',
  'txt-label-deposit': 'Deposit',
  'txt-label-withdrawal': 'Withdrawal',
  'txt-label-profile': 'Profile',
  'txt-label-security': 'Security',
  'txt-label-bank-account': "Bank's Account",
  'txt-label-authorization': 'Authorization',
  'txt-label-authorization-person': 'Authorized Person',
  'txt-label-authorization-person-other': 'Other Authorized Person',
  'txt-label-authorization-type': 'Authorized transaction type',
  'txt-label-order-statement': 'Order Statement',
  'txt-label-order-cond-statement': 'Order Condition Statement',
  'txt-label-cash-statement': 'Cash Statement',
  'txt-label-securities-statement': 'Securities Statement',
  'txt-label-order-del': 'Delete',
  'txt-label-order-edit': 'Edit',
  'txt-label-trading-fee': 'Trading fee',
  'txt-label-condition': 'Condition',
  'txt-label-order-history': 'Order history',
  'txt-label-order-cond-history': 'Order condition history',
  'txt-label-channel': 'Channel',
  'txt-label-account-info': 'Account Info',
  'txt-label-fullname': 'Full name',
  'txt-label-identification': 'Identification',
  'txt-label-issued-on': 'Issued on',
  'txt-label-place': 'Place',
  'txt-label-phone-num': 'Phone number',
  'txt-label-phone': 'Phone number',
  'txt-label-date-birth': 'Date of birth',
  'txt-label-sex': 'Sex',
  'txt-label-cif-no': 'CIF No.',
  'txt-label-vsd-no': 'VSD No.',
  'txt-label-male': 'Male',
  'txt-label-female': 'Female',
  'txt-label-nationality': 'Nationality',
  'txt-label-contact-info': 'Contact information',
  'txt-label-permanent-address': 'Permanent Address',
  'txt-label-address': 'Address',
  'txt-label-province': 'Province',
  'txt-label-branch': 'Branch',
  'txt-label-beneficiary-bank': 'Beneficiary bank',
  'txt-label-account-holder': 'Account holder',
  'txt-label-account-num': 'Account number',
  'txt-label-account-second': 'Second account',
  'txt-label-login-info': 'Login Information',
  'txt-label-login-account': 'Account Login',
  'txt-label-customer-name': 'Customer name',
  'txt-label-current-password': 'Current password',
  'txt-label-default-account': 'Default Account',
  'txt-label-authentication-registered': 'Authentication registered',
  'txt-label-change-pass-pinetree':
    "Change password Thien Viet Securities's account",
  'txt-label-old-pass': 'Old password',
  'txt-label-new-pass': 'New password',
  'txt-label-new-pass-confirm': 'New password confirm',
  'txt-label-authen-otp': 'OTP authentication',
  'txt-label-cash-advance': 'Cash advance',
  'txt-label-recipient-account': 'Recipient account',
  'txt-label-amount-withdraw': 'Amount withdraw',
  'txt-label-margin-list': 'Margin list',
  'txt-label-look-right-info': 'Look up rights implementation information',
  'txt-label-default-watchlist': 'My watchlist',
  'txt-label-cash-advance-payment': 'Cash advance',
  'txt-label-old-account': 'Old Account',
  'txt-label-new-account': 'New Account',
  'txt-label-quarterly': 'Quarterly',
  'txt-label-annual': 'Annual',
  'txt-label-income-statement': 'Income Statement',
  'txt-label-balance-sheet': 'Balance Sheet',
  'txt-label-ratios': 'Ratios',
  'txt-label-items': 'Items',
  'txt-label-today': 'Today',
  'txt-label-month': 'Month',
  'txt-label-monday': 'Mo',
  'txt-label-tuesday': 'Tu',
  'txt-label-wednesday': 'We',
  'txt-label-thursday': 'Th',
  'txt-label-friday': 'Fr',
  'txt-label-saturday': 'Sa',
  'txt-label-sunday': 'Su',
  'txt-label-major-shareholders': 'Major Shareholders',
  'txt-label-legal-representative': 'Legal Representative',
  'txt-label-CS': 'Basic',

  'txt-export-excel': 'Export Excel',
  'txt-export-pdf': 'Export PDF',

  'txt-verification-methods': 'Verification methods',
  'txt-choose-verification-methods':
    'Please select your desired verification method',
  'txt-smartotp-pinetree': 'Use Thien Viet Securities OTP generator',
  'txt-matrix': 'Square matrix',
  'txt-regis-counter': 'Register at counter',
  'txt-otp-sent-to': '',
  'txt-lost-verification': 'Lost your verification?',

  'txt-enter-otp': 'Please enter OTP to confirm',
  'txt-sub-smartotp':
    'Please enter Smart OTP code has been generated from SmartOTP apps',
  'txt-sub-otp': 'Enter SMS OTP code has been sent to',
  'txt-learn-more': 'Learn more',
  'txt-cant-access': 'Can’t access your favourite device now?',
  'txt-change-method': 'Change confirmation method',
  'txt-resend': 'Resend',
  'txt-enter-matrix': 'Please enter Matrix to confirm',
  'txt-hotline-support':
    'Do you want to change the above profile information? Please contact Thien Viet Securities hotline for support.',
  'txt-make-sure-can-access':
    'Make sure you can access the current authentication method to make changes to your account security information',
  'txt-make-verify-otp-correct':
    'Verify OTP after entering both passwords correctly',
  'txt-code-smartotp-to-confirm':
    'Please enter the security code from SmartOTP app to confirm transaction',
  'txt-code-otp-to-confirm': 'Please enter the OTP number sent to phone number',
  'txt-confirm-transaction': 'to confirm transaction',
  'txt-code-matrix-to-confirm':
    'Please enter MATRIX code to confirm transaction',
  'txt-gd':
    'To make a deposit into the Securities account automatically. Please make a Bank transfer to 1 of your Bank accounts with the EXACT information as shown in the sample',
  'txt-warning-cashout-fee': 'SMS OTP fee excluded (if any)',
  'txt-warning-cashout':
    'At the moment, online transfer only support from 08h00 to 15h30, please retry again in suitable time',
  'txt-warning-relogin': 'Your session is closed, please relogin.',

  'algo.menu.txt-ptdt': 'Analytic tools',
  'algo.menu.txt-bdkt': 'Technical chart',
  'algo.menu.txt-pttt': 'Market watch',
  'algo.menu.txt-ptcp': 'Stock watch',
  'algo.menu.txt-lcp': 'Stock filter',
  'algo.menu.txt-thcb': 'Filter signals',

  'algo.bdkt.txt-overview': 'Overview',
  'algo.bdkt.txt-money-flows': 'Money Flows',
  'algo.bdkt.txt-statistical': 'Statistical',
  'algo.bdkt.txt-overview-2': 'Overview',
  'algo.bdkt.txt-reference-index': 'Reference Index',
  'algo.bdkt.txt-Open-Index': 'Open Index',
  'algo.bdkt.txt-low-high': 'Low Index - High Index',
  'algo.bdkt.txt-trading-volume': 'Trading volume',
  'algo.bdkt.txt-trading-value': 'Trading value',
  'algo.bdkt.txt-bil': 'bil.',
  'algo.bdkt.txt-foreigner-trading': 'Foreigner trading',
  'algo.bdkt.txt-buy-vol': 'Buy vol.',
  'algo.bdkt.txt-sell-vol': 'Sell vol.',
  'algo.bdkt.txt-net-buy-vol': 'Net buy vol.',
  'algo.bdkt.txt-buy-val': 'Buy val.',
  'algo.bdkt.txt-sell-val': 'Sell val.',
  'algo.bdkt.txt-net-buy-val': 'Net buy val.',
  'algo.bdkt.txt-foreigner-buy-val': 'Foreigner net buy',
  'algo.bdkt.txt-intraday': 'Intraday',
  'algo.bdkt.txt-10-day': '10 days',
  'algo.bdkt.txt-advance-decline-nochange':
    'No. of Advances, Declines, No-changes stocks',
  'algo.bdkt.txt-no-change': 'No-changes',
  'algo.bdkt.txt-decline': 'Declines',
  'algo.bdkt.txt-advance': 'Advances',
  'algo.bdkt.txt-money-flow-distribution': 'Money Flows Distribution',

  'algo.pttt.txt-market': 'Market',
  'algo.pttt.txt-institutions': 'Institutions',
  'algo.pttt.txt-industry': 'Industry',
  'algo.pttt.txt-money-flow': 'Money Flows',
  'algo.pttt.txt-matching': 'Matching',
  'algo.pttt.txt-matching-putthrough': 'Matching and Put through',
  'algo.pttt.txt-contribution-index': 'TOP contribution to INDEX ',
  'algo.pttt.txt-contrib-index-per': 'Contrib to INDEX (%)',
  'algo.pttt.txt-contrib-index-point': 'Contrib to INDEX (Point)',
  'algo.pttt.txt-trading-volume': 'Trading volume',
  'algo.pttt.txt-Liquidity': 'Liquidity',
  'algo.pttt.txt-Current': 'Current',
  'algo.pttt.txt-PreDay': 'Prev Day',
  'algo.pttt.txt-1week': '1 week',
  'algo.pttt.txt-2week': '2 weeks',
  'algo.pttt.txt-1month': '1 month',
  'algo.pttt.txt-market-capitalization': 'Market capitalization',
  'algo.pttt.txt-Foreigner-trading-volume': 'Foreigner trading volume',
  'algo.pttt.txt-Foreigner-trading-value': 'Foreigner trading value',
  'algo.pttt.txt-Proprietary-trading-volume': 'Proprietary trading volume',
  'algo.pttt.txt-Proprietary-trading-value': 'Proprietary trading value',
  'algo.pttt.txt-industry-contrib-index':
    'TOP  industry contribution to INDEX ',
  'algo.pttt.txt-Foreigner-trading-by-industries':
    'Foreigner trading by industries',
  'algo.pttt.txt-Proprietary-trading-by-industries':
    'Proprietary trading by industries',
  'algo.pttt.txt-Trading-value-by-industries': 'Trading value by industries',
  'algo.pttt.txt-Market-breadth': 'Market breadth',
  'algo.pttt.txt-net-money-flow': 'Net money flows',
  'algo.pttt.txt-advance': 'Advances',
  'algo.pttt.txt-no-change': 'No changes',
  'algo.pttt.txt-decline': 'Declines',

  'algo.ptcp.txt-overview': 'Overview',
  'algo.ptcp.txt-price-history': 'Price History',
  'algo.ptcp.txt-Finance': 'Finance',
  'algo.ptcp.txt-Profile': 'Profile',
  'algo.ptcp.txt-Events': 'Events',
  'algo.ptcp.txt-News': 'News',
  'algo.ptcp.txt-Reference-Price': 'Reference Price',
  'algo.ptcp.txt-Open-price': 'Open price',
  'algo.ptcp.txt-low-high': 'High price - Low price',
  'algo.ptcp.txt-trading-volume': 'Trading volume',
  'algo.ptcp.txt-trading-value': 'Trading value',
  'algo.ptcp.txt-10-day-avg-vol': '10-day avg. vol.',
  'algo.ptcp.txt-Market-cap': 'Market cap.',
  'algo.ptcp.txt-Outstanding-shares': 'Outstanding shares',
  'algo.ptcp.txt-Sector': 'Sector',
  'algo.ptcp.txt-Order-book': 'Order book',
  'algo.ptcp.txt-Best-bid': 'Best bid',
  'algo.ptcp.txt-Best-ask': 'Best ask',
  'algo.ptcp.txt-Matched-details': 'Matched details',
  'algo.ptcp.txt-Matched-analysis': 'Matched analysis',
  'algo.ptcp.txt-Active-buy-vol': 'Active buy vol.',
  'algo.ptcp.txt-Active-sell-vol': 'Active sell vol.',
  'algo.ptcp.txt-B': 'B',
  'algo.ptcp.txt-S': 'S',
  'algo.ptcp.txt-Money-Flow': 'Money Flow',
  'algo.ptcp.txt-Foreigner-trading': 'Foreigner trading',
  'algo.ptcp.txt-Buy-vol': 'Buy vol.',
  'algo.ptcp.txt-Sell-vol': 'Sell vol.',
  'algo.ptcp.txt-Net-buy-vol': 'Net buy vol.',
  'algo.ptcp.txt-Buy-val': 'Buy val.',
  'algo.ptcp.txt-Sell-val': 'Sell val.',
  'algo.ptcp.txt-Net-buy-val': 'Net buy val.',
  'algo.ptcp.txt-Foreigner-net-buy': 'Foreigner net buy',
  'algo.ptcp.txt-intraday': 'Intraday',
  'algo.ptcp.txt-10-days': '10 days',
  'algo.ptcp.txt-Search': 'Search',
  'algo.ptcp.txt-Trade-date': 'Trade date',
  'algo.ptcp.txt-Close-price': 'Close price',
  'algo.ptcp.txt-Change': 'Change',
  'algo.ptcp.txt-Ref-price': 'Ref. price',
  'algo.ptcp.txt-Foreigner-buy-vol': 'Foreigner buy vol.',
  'algo.ptcp.txt-Proprietary-buy-vol': 'Proprietary buy vol.',
  'algo.ptcp.txt-matched': 'Matched',
  'algo.ptcp.txt-put-through': 'Put through',
  'algo.ptcp.txt-volume': 'Volume',
  'algo.ptcp.txt-value': 'Value',
  'algo.ptcp.txt-Income-statement': 'Income statement',
  'algo.ptcp.txt-Balance-sheet': 'Balance sheet',
  'algo.ptcp.txt-Cash-flow-statement': 'Cash flow statement',
  'algo.ptcp.txt-Profitability': 'Profitability',
  'algo.ptcp.txt-Quarter': 'Quarter',
  'algo.ptcp.txt-Year': 'Year',
  'algo.ptcp.txt-bil-vnd': '(Unit: Bil. VND)',
  'algo.ptcp.txt-unit-per': '(Unit: %)',
  'algo.ptcp.txt-Net-revenue': 'Net revenue',
  'algo.ptcp.txt-Gross-profit': 'Gross profit',
  'algo.ptcp.txt-Operating-profit': 'Operating profit',
  'algo.ptcp.txt-Net-profit': 'Net profit',
  'algo.ptcp.txt-Total-assets': 'Total assets',
  'algo.ptcp.txt-Current-liabilities': 'Current liabilities',
  'algo.ptcp.txt-Non-current-liabilities': 'Non-current liabilities',
  'algo.ptcp.txt-Total-equity': 'Total equity',
  'algo.ptcp.txt-Operating-cash-flow': 'Operating cash flow',
  'algo.ptcp.txt-Financing-cash-flow': 'Financing cash flow',
  'algo.ptcp.txt-Investing-cash-flow': 'Investing cash flow',
  'algo.ptcp.txt-Free-cash-flow': 'Free cash flow',
  'algo.ptcp.txt-Gross-margin': 'Gross margin',
  'algo.ptcp.txt-Net-margin': 'Net margin',
  'algo.ptcp.txt-Growth-Value-Quality': 'Growth - Value - Quality',
  'algo.ptcp.txt-market': 'Market',
  'algo.ptcp.txt-val-12m': 'Value (T12M)',
  'algo.ptcp.txt-EPS-growth': 'EPS growth (%)',
  'algo.ptcp.txt-Growth': 'Growth (YoY)',
  'algo.ptcp.txt-Revenue': 'Revenue (%)',
  'algo.ptcp.txt-CAGR': 'CAGR (3 year)',
  'algo.ptcp.txt-Quality': 'Quality',
  'algo.ptcp.txt-Introduction': 'Introduction',
  'algo.ptcp.txt-Basic-information': 'Basic information',
  'algo.ptcp.txt-Subsidiaries': 'Subsidiaries',
  'algo.ptcp.txt-Associates': 'Associates',
  'algo.ptcp.txt-Others': 'Others',
  'algo.ptcp.txt-Peers': 'Peers',
  'algo.ptcp.txt-Board-managers': 'Board managers',
  'algo.ptcp.txt-Large-shareholders': 'Large shareholders',
  'algo.ptcp.txt-Listed-date': 'Listed date',
  'algo.ptcp.txt-Listed-exchange': 'Listed exchange',
  'algo.ptcp.txt-Listed-price': 'Listed price',
  'algo.ptcp.txt-Listed-shares': 'Listed shares',
  'algo.ptcp.txt-Market-capitalization': 'Market capitalization',
  'algo.ptcp.txt-Outstanding-shares': 'Outstanding shares',
  'algo.ptcp.txt-Sector-ICB': 'Sector ICB{{name}}',
  'algo.ptcp.txt-Name': 'Name',
  'algo.ptcp.txt-Capital-bil': 'Capital (bil.)',
  'algo.ptcp.txt-ownership': '% ownership',
  'algo.ptcp.txt-Ticker': 'Ticker',
  'algo.ptcp.txt-Price': 'Price',
  'algo.ptcp.txt-vol': 'Vol.',
  'algo.ptcp.txt-Time': 'Time',
  'algo.ptcp.txt-Title': 'Title',
  'algo.ptcp.txt-Source': 'Source',
  'algo.ptcp.txt-Events': 'Events',
  'algo.ptcp.txt-Insider-transactions': 'Insider transactions',
  'algo.ptcp.txt-Announced-date': 'Announced date',
  'algo.ptcp.txt-Description': 'Description',
  'algo.ptcp.txt-Ex-date': 'Ex date',
  'algo.ptcp.txt-Last-register-date': 'Last register date',
  'algo.ptcp.txt-Effective-date': 'Effective date',
  'algo.ptcp.txt-Trans-type': 'Trans type',
  'algo.ptcp.txt-Notifier': 'Notifier',
  'algo.ptcp.txt-Position': 'Position',
  'algo.ptcp.txt-Related-person': 'Related person',
  'algo.ptcp.txt-Relationship': 'Relationship',
  'algo.ptcp.txt-Reg-quantity': 'Reg. quantity',
  'algo.ptcp.txt-Real-quantity': 'Real quantity',
  'algo.ptcp.txt-Held-quantity': 'Held quantity',
  'algo.ptcp.txt-Start-date': 'Start date',
  'algo.ptcp.txt-End-date': 'End date',
  'algo.ptcp.txt-Status': 'Status',

  'algo.lcp.txt-Filters': 'Filters',
  'algo.lcp.txt-Your-Filters': 'Your filter',
  'algo.lcp.txt-Select-filter-condition': 'Select filter condition',
  'algo.lcp.txt-Select-criteria': 'Select criteria',
  'algo.lcp.txt-Exchange': 'Exchange',
  'algo.lcp.txt-Industry': 'Industry',
  'algo.lcp.txt-Input-value': 'Input or drag a value',
  'algo.lcp.txt-Reload-result': 'Reload result',
  'algo.lcp.txt-Clear-all': 'Clear all',
  'algo.lcp.txt-Result': 'Result',
  'algo.lcp.txt-Add-to-watchlist': 'Add to watchlist',
  'algo.lcp.txt-Delete-watchlist': 'Delete',
  'algo.lcp.txt-Save': 'Save',
  'algo.lcp.txt-Save-2': 'Save',
  'algo.lcp.txt-Save-new': 'Save new',
  'algo.lcp.txt-Price-change-per-week': 'Price change / week',
  'algo.lcp.txt-Price-change-per-month': 'Price change / month',
  'algo.lcp.txt-del-bl-success': 'Delete successful',
  'algo.lcp.txt-select-all': 'Select all',

  'algo.cb.txt-Criteria': 'Signals',
  'algo.cb.txt-Manage-signals': 'Manage signals',
  'algo.cb.txt-Set-signals': 'Set signals',
  'algo.cb.txt-Trade-date': 'Trade date',
  'algo.cb.txt-Exchange': 'Exchange',
  'algo.cb.txt-Ticker': 'Ticker',
  'algo.cb.txt-Name': 'Name',
  'algo.cb.txt-Market-cap': 'Market cap.',
  'algo.cb.txt-Price': 'Price',
  'algo.cb.txt-up-down': '+/-',
  'algo.cb.txt-5-day-avg': '5-day avg. vol.',
  'algo.cb.txt-Signal': 'Signal',
  'algo.cb.txt-No-data': 'No data!',
  'algo.cb.txt-Criteria-2': 'Signals',
  'algo.cb.txt-Delete': 'Delete',
  'algo.cb.txt-Edit': 'Edit',
  'algo.cb.txt-Cancel': 'Cancel',
  'algo.cb.txt-Create-2': 'Create signals',
  'algo.cb.txt-View': 'View',
  'algo.cb.txt-Backtest-resul': 'Result Backtest for {{symbol}}',
  'algo.cb.txt-year': 'Year',
  'algo.cb.txt-buy-signal': 'Buy Signal',
  'algo.cb.txt-sell-signal': 'Sell Signal',
  'algo.cb.txt-buy-order': 'Buy Order',
  'algo.cb.txt-sell-order': 'Sell Order',
  'algo.cb.txt-buy-gain': 'Buy Gain',
  'algo.cb.txt-buy-lost': 'Buy Lost',
  'algo.cb.txt-stop-lost': 'Stop Lost',
  'algo.cb.txt-take-profit': 'Take Profit',

  'algo.industry.0001': 'Oil & Gas',
  'algo.industry.1300': 'Chemicals',
  'algo.industry.1700': 'Basic Resources',
  'algo.industry.2300': 'Construction & Materials',
  'algo.industry.2700': 'Industrial Goods & Services',
  'algo.industry.3300': 'Automobiles & Parts',
  'algo.industry.3500': 'Food & Beverage',
  'algo.industry.3700': 'Personal & Household Goods',
  'algo.industry.5300': 'Retail',
  'algo.industry.5500': 'Media',
  'algo.industry.5700': 'Travel & Leisure',
  'algo.industry.6000': 'Telecommunications',
  'algo.industry.7530': 'Electricity',
  'algo.industry.8300': 'Banks',
  'algo.industry.8500': 'Insurance',
  'algo.industry.8600': 'Real Estates',
  'algo.industry.8700': 'Financial Services',
  'algo.industry.9000': 'Technology',

  'algo.industry.0530': 'Oil & Gas Producers',
  'algo.industry.0570': 'Oil Equipment, Services & Distribution',
  'algo.industry.1350': 'Chemicals',
  'algo.industry.1730': 'Forestry & Paper',
  'algo.industry.1750': 'Industrial Metals',
  'algo.industry.1770': 'Mining',
  'algo.industry.2350': 'Construction & Materials',
  'algo.industry.2710': 'Aerospace & Defense',
  'algo.industry.2720': 'General Industrials',
  'algo.industry.2730': 'Electronic & Electrical Equipment',
  'algo.industry.2750': 'Industrial Engineering',
  'algo.industry.2770': 'Industrial Transportation',
  'algo.industry.2790': 'Support Services',
  'algo.industry.3350': 'Automobiles & Parts',
  'algo.industry.3530': 'Beverages',
  'algo.industry.3570': 'Food Producers',
  'algo.industry.3720': 'Household Goods',
  'algo.industry.3740': 'Leisure Goods',
  'algo.industry.3760': 'Personal Goods',
  'algo.industry.3780': 'Tobacco',
  'algo.industry.4530': 'Health Care Equipment & Services',
  'algo.industry.4570': 'Pharmaceuticals & Biotechnology',
  'algo.industry.5330': 'Food & Drug Retailers',
  'algo.industry.5370': 'General Retailers',
  'algo.industry.5550': 'Media',
  'algo.industry.5750': 'Travel & Leisure',
  'algo.industry.6530': 'Fixed Line Telecommunications',
  'algo.industry.6570': 'Mobile Telecommunications',
  'algo.industry.7570': 'Gas, Water & Multiutilities',
  'algo.industry.8350': 'Banks',
  'algo.industry.8530': 'Nonlife Insurance',
  'algo.industry.8570': 'Life Insurance',
  'algo.industry.8630': 'Real Estate',
  'algo.industry.8770': 'General Financial',
  'algo.industry.8980': 'Equity Investment Instruments',
  'algo.industry.8990': 'Nonequity Investment Instruments',
  'algo.industry.9530': 'Software & Computer Services',
  'algo.industry.9570': 'Technology Hardware & Equipment',

  'algo.chart.top-anh-huong':
    'Represent contribution points/percent of Top 30 influential tickers to changes in the indexes, including Top 15 positive contributors and Top 15 negative contributors. Data date: ',
  'algo.chart.kl-giao-dich':
    'Represent whether the INDEX trading volume is focusing on which tickers. The unit of value is mil. VND. Data date: ',
  'algo.chart.bieu-do-von-hoa':
    'Represent the market cap. distributions of all tickers within INDEX. Data date: ',
  'algo.chart.thanh-khoan':
    'Represent the current Total Trading Value of the indexes comparing to the Value at the same time of the previous session, avg. 1-week, 2-week and 1-month. Data date: ',
  'algo.chart.kl-kn-mua-rong':
    'Green color represents the foreigner net buying. Red color represents the foreigner net selling. Data included Stock and ETF. Data date: ',
  'algo.chart.gt-kn-mua-rong':
    'Green color represents the foreigner net buying. Red color represents the foreigner net selling. Data included Stock and ETF. The unit of value is mil. VND. Data date: ',
  'algo.chart.kl-td-mua-rong':
    'Green color represents the proprietary net buying. Red color represents the proprietary net selling. Data date: ',
  'algo.chart.gt-td-mua-rong':
    'Green color represents the proprietary net buying. Red color represents the proprietary net selling. The unit of value is mil. VND. Data date: ',
  'algo.chart.top-nganh-index':
    'Represent the contributions of industries to INDEX. Green color for positive contributors (increase INDEX), red color for negative contributors (decrease INDEX). Data date: ',
  'algo.chart.kn-mua-rong-theo-nganh':
    'Green color represents the foreigner net buying. Red color represents the foreigner net selling. Data included Stock and ETF. The unit of value is mil. VND. Data date: ',
  'algo.chart.td-mua-rong-theo-nganh':
    'Green color represents the proprietary net buying. Red color represents the proprietary net selling. The unit of value is mil. VND. Data date: ',
  'algo.chart.gt-gd-theo-nganh':
    "Represent industries' trading value (Unit: Mil. VND). Green color for positive contributors (increase INDEX), red color for negative contributors (decrease INDEX).",
  'algo.chart.do-rong-thi-truong':
    'Represent the percentage of advances, declines and no-changes stocks intraday.',
  'algo.chart.dong-tien-dong':
    'Represent the net active buy trading value intraday.',

  'algo.bl.type.CO_TUC': 'Dividends',
  'algo.bl.type.DINH_GIA': 'Valuation',
  'algo.bl.type.GIA_KHOI_LUONG': 'Price and Volume',
  'algo.bl.type.HIEU_QUA_HOAT_DONG': 'Efficiency',
  'algo.bl.type.KHA_NANG_SINH_LOI': 'Profitability',
  'algo.bl.type.KHA_NANG_THANH_TOAN_DAI_HAN': 'Solvency',
  'algo.bl.type.KHA_NANG_THANH_TOAN_NGAN_HAN': 'Liquidity Ratios',
  'algo.bl.type.KHOI_NGOAI': 'Foreigner Trading',
  'algo.bl.type.QUY_MO': 'Size',
  'algo.bl.type.SUC_KHOE_TAI_CHINH': 'Financial Health',
  'algo.bl.type.TANG_TRUONG': 'Growth',
  'algo.bl.type.TIN_HIEU_KY_THUAT': 'Technical Indicators',

  'algo.bl.CO_TUC.DVD_PAID_RATE': 'Dividend payout ratio (%)',
  'algo.bl.CO_TUC.DVD_PER_P': 'Dividend yield (%)',
  'algo.bl.CO_TUC.DVD_1Y': 'DPS 4-quarter (VND)',
  'algo.bl.CO_TUC.EPS': 'EPS 4-quarter (VND)',

  'algo.bl.DINH_GIA.PE': 'PE (x)',
  'algo.bl.DINH_GIA.PB': 'PB (x)',
  'algo.bl.DINH_GIA.PS': 'PS (x)',
  'algo.bl.DINH_GIA.EV_PER_EBIT': 'EV/EBIT (x)',
  'algo.bl.DINH_GIA.EV_PER_EBITDA': 'EV/EBITDA (x)',
  'algo.bl.DINH_GIA.P_PER_FCF': 'P/FCF (x)',

  'algo.bl.GIA_KHOI_LUONG.VOL_PER_5D': 'Volume vs. 5-day avg volume (x)',
  'algo.bl.GIA_KHOI_LUONG.VOL_PER_10D': 'Volume vs. 10-day avg volume (x)',
  'algo.bl.GIA_KHOI_LUONG.VOL_PER_20D': 'Volume vs. 20-day avg volume (x)',
  'algo.bl.GIA_KHOI_LUONG.VOL_10D_VS_3M':
    '10-day avg volume vs 3-month avg volume (x)',
  'algo.bl.GIA_KHOI_LUONG.VAL_PER_5D': 'Value vs. 5-day avg value (x)',
  'algo.bl.GIA_KHOI_LUONG.VAL_PER_10D': 'Value vs. 10-day avg value (x)',
  'algo.bl.GIA_KHOI_LUONG.VAL_PER_20D': 'Value vs. 20-day avg value (x)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_20D': 'Price vs. MA 20 (%)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_50D': 'Price vs. MA 50 (%)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_130D': 'Price vs. MA 130 (%)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_200D': 'Price vs. MA 200 (%)',
  'algo.bl.GIA_KHOI_LUONG.P_CHANGE_1W': '1-week return (%)',
  'algo.bl.GIA_KHOI_LUONG.P_CHANGE_1M': '1-month return (%)',
  'algo.bl.GIA_KHOI_LUONG.P_CHANGE_3M': '3-month return (%)',
  'algo.bl.GIA_KHOI_LUONG.P_CHANGE_6M': '6-month return (%)',
  'algo.bl.GIA_KHOI_LUONG.P_CHANGE_1Y': '1-year return (%)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_MAX_52W': 'Price vs. 52-week High (%)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_MIN_52W': 'Price vs. 52-week Low (%)',
  'algo.bl.GIA_KHOI_LUONG.BETA30D': 'Beta 30-day',
  'algo.bl.GIA_KHOI_LUONG.BETA60D': 'Beta 60-day',
  'algo.bl.GIA_KHOI_LUONG.BETA90D': 'Beta 90-day',
  'algo.bl.GIA_KHOI_LUONG.RS1W': '1-week Relative Strength (%)',
  'algo.bl.GIA_KHOI_LUONG.RS1M': '1-month Relative Strength (%)',
  'algo.bl.GIA_KHOI_LUONG.RS3M': '3-month Relative Strength (%)',
  'algo.bl.GIA_KHOI_LUONG.RS6M': '6-month Relative Strength (%)',
  'algo.bl.GIA_KHOI_LUONG.RS1Y': '1-year Relative Strength (%)',
  'algo.bl.GIA_KHOI_LUONG.STD_P_1Y':
    'Standard Deviation of Daily Return, 1 year (%)',
  'algo.bl.GIA_KHOI_LUONG.TOTAL_VOL': 'Current volume (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_5D': '5-day avg volume (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_10D': '10-day avg volume (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_20D': '20-day avg volume (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_30D': '30-day avg volume (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_60D': '60-day avg volume (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_YTD': 'YTD avg volume (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_1Y': '1-year avg volume (shares)',
  'algo.bl.GIA_KHOI_LUONG.TOTAL_VAL': 'Current value (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_5D': '5-day avg value (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_10D': '10-day avg value (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_20D': '20-day avg value (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_30D': '30-day avg value (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_60D': '60-day avg value (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_YTD': 'YTD avg value (shares)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_1Y': '1-year avg value (shares)',

  'algo.bl.HIEU_QUA_HOAT_DONG.INVENTORY_TURN': 'Inventory turnover (x)',
  'algo.bl.HIEU_QUA_HOAT_DONG.INVENTORY_DAYS': 'Days of inventory (days)',
  'algo.bl.HIEU_QUA_HOAT_DONG.REC_TURN': 'Receivable turnover (x)',
  'algo.bl.HIEU_QUA_HOAT_DONG.REC_DAYS': 'Days of receivable (days)',
  'algo.bl.HIEU_QUA_HOAT_DONG.PAY_TURN': 'Payables turnover (x)',
  'algo.bl.HIEU_QUA_HOAT_DONG.PAY_DAYS': 'Days of payables (days)',
  'algo.bl.HIEU_QUA_HOAT_DONG.CAPITAL_TURN': 'Working capital turnover (x)',
  'algo.bl.HIEU_QUA_HOAT_DONG.FIXED_ASSETS_TURN': 'Fixed assets turnover (x)',
  'algo.bl.HIEU_QUA_HOAT_DONG.ASSETS_TURN': 'Total assets turnover (x)',

  'algo.bl.KHA_NANG_SINH_LOI.ROA': 'ROA (%)',
  'algo.bl.KHA_NANG_SINH_LOI.ROE': 'ROE (%)',
  'algo.bl.KHA_NANG_SINH_LOI.GR_MARGIN': 'Gross margin (%)',
  'algo.bl.KHA_NANG_SINH_LOI.OPERATING_MARGIN': 'Operating margin (%)',
  'algo.bl.KHA_NANG_SINH_LOI.BF_TAX_MARGIN': 'Pretax margin (%)',
  'algo.bl.KHA_NANG_SINH_LOI.NET_MARGIN': 'Net margin (%)',
  'algo.bl.KHA_NANG_SINH_LOI.ROIC': 'ROIC (%)',
  'algo.bl.KHA_NANG_SINH_LOI.ROCE': 'ROCE (%)',

  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.DEBT_PER_ASSETS':
    'Debt-to-assets ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.DEBT_PER_CAPITAL':
    'Debt-to-capital ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.DEBT_PER_EQUITY':
    'Debt-to-equity ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.LEVERAGE': 'Financial leverage (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.INT_COVERAGE': 'Interest coverage (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.CASH_PER_ASSETS':
    'Cash-to-assets ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.FCF_PER_LT_DEBT':
    'FCF to long-term debt ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.NET_DEBT_PER_EQUITY':
    'Net debt to equity ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.NET_DEBT_PER_TANGIBLE_EQUITY':
    'Net debt to tangible equity ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.LT_DEBT_PER_ASSETS':
    'Long-term debt to assets ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.TANGIBLE_ASSETS_PER_EQUITY':
    'Tangible assets to equity ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.NET_DEBT_PER_MC':
    'Net-debt to market cap. ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.NET_DEBT_PER_TANGIBLE_ASSETS':
    'Net-debt to tangible assets ratio (x)',

  'algo.bl.KHA_NANG_THANH_TOAN_NGAN_HAN.CURR_RATIO': 'Current ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_NGAN_HAN.QUICK_RATIO': 'Quick ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_NGAN_HAN.CASH_RATIO': 'Cash ratio (x)',
  'algo.bl.KHA_NANG_THANH_TOAN_NGAN_HAN.CASH_TURN':
    'Cash conversion cycle (days)',

  'algo.bl.KHOI_NGOAI.F_BUY_VALUE': 'Foreigner Buy Value (Mil. VND)',
  'algo.bl.KHOI_NGOAI.F_SELL_VALUE': 'Foreigner Sell Value (Mil. VND)',
  'algo.bl.KHOI_NGOAI.F_NET_BUY_VALUE': 'Foreigner Net Buy Value (Mil. VND)',
  'algo.bl.KHOI_NGOAI.F_BUY_VAL_PER_5D':
    'Foreigner Buy value vs. 5-day avg (x)',
  'algo.bl.KHOI_NGOAI.F_BUY_VAL_PER_10D':
    'Foreigner Buy value vs. 10-day avg (x)',
  'algo.bl.KHOI_NGOAI.F_BUY_VAL_PER_20D':
    'Foreigner Buy value vs. 20-day avg (x)',
  'algo.bl.KHOI_NGOAI.F_SELL_VAL_PER_5D':
    'Foreigner Sell value vs. 5-day avg (x)',
  'algo.bl.KHOI_NGOAI.F_SELL_VAL_PER_10D':
    'Foreigner Sell value vs. 10-day avg (x)',
  'algo.bl.KHOI_NGOAI.F_SELL_VAL_PER_20D':
    'Foreigner Sell value vs. 20-day avg (x)',
  'algo.bl.KHOI_NGOAI.F_NET_BUY_VOLUME':
    'Current foreigner net buy volume (shares)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_5D':
    '5-day avg foreigner net buy volume (shares)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_10D':
    '10-day avg foreigner net buy volume (shares)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_20D':
    '20-day avg foreigner net buy volume (shares)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_30D':
    '30-day avg foreigner net buy volume (shares)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_60D':
    '60-day avg foreigner net buy volume (shares)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_YTD':
    'YTD avg foreigner net buy volume (shares)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_1Y':
    '1-year avg foreigner net buy volume (shares)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_5D':
    '5-day avg foreigner net buy value (Mil. VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_10D':
    '10-day avg foreigner net buy value (Mil. VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_20D':
    '20-day avg foreigner net buy value (Mil. VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_30D':
    '30-day avg foreigner net buy value (Mil. VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_60D':
    '60-day avg foreigner net buy value (Mil. VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_YTD':
    'YTD avg foreigner net buy value (Mil. VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_1Y':
    '1-year avg foreigner net buy value (Mil. VND)',

  'algo.bl.QUY_MO.MC': 'Market cap. (Bil VND)',
  'algo.bl.QUY_MO.EV': 'EV (Bil. VND)',

  'algo.bl.SUC_KHOE_TAI_CHINH.M_SCORE': 'M-Score',
  'algo.bl.SUC_KHOE_TAI_CHINH.F_SCORE': 'F-Score',
  'algo.bl.SUC_KHOE_TAI_CHINH.Z_SCORE': 'Z-Score',
  'algo.bl.SUC_KHOE_TAI_CHINH.C_SCORE': 'C-Score',
  'algo.bl.SUC_KHOE_TAI_CHINH.MAGIC_SCORE': 'Magic Formula Score',

  'algo.bl.TANG_TRUONG.NET_INC_GROWTH':
    'NI growth trailing 4Q vs. prior trailing 4Q (%)',
  'algo.bl.TANG_TRUONG.EPS_GROWTH':
    'EPS growth trailing 4Q vs. prior trailing 4Q (%)',
  'algo.bl.TANG_TRUONG.REV_GROWTH_1Y':
    'Revenue growth trailing 4Q vs. prior trailing 4Q (%)',
  'algo.bl.TANG_TRUONG.DVD_GROWTH':
    'DPS growth trailing 4Q vs. prior trailing 4Q (%)',
  'algo.bl.TANG_TRUONG.OPERATING_INC_GROWTH':
    'OI growth trailing 4Q vs. prior trailing 4Q (%)',
  'algo.bl.TANG_TRUONG.GR_PROFIT_GROWTH':
    'Gross profit growth trailing 4Q vs. prior trailing 4Q (%)',
  'algo.bl.TANG_TRUONG.NET_INC_GROWTH1':
    'NI growth most recent quarter vs. prior year quarter (%)',
  'algo.bl.TANG_TRUONG.REV_GROWTH1':
    'Revenue growth most recent quarter vs. prior year quarter (%)',
  'algo.bl.TANG_TRUONG.OPERATING_INC_GROWTH1':
    'OI growth most recent quarter vs. prior year quarter (%)',
  'algo.bl.TANG_TRUONG.GR_PROFIT_GROWTH1':
    'Gross profit growth most recent quarter vs. prior year quarter (%)',

  'algo.bl.TIN_HIEU_KY_THUAT.RSI_14': 'RSI (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.STOCHASTIC_14_3_3': 'STOCH (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.ADI_14': 'ADX (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.STOCHASTIC_RSI_14': 'STOCHRSI (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.ATR_14': 'ATR (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.WILLIAMR_14': 'William %R (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.MACD_12_26_9': 'MACD (12,26,9)',
  'algo.bl.TIN_HIEU_KY_THUAT.MFI_14': 'MFI (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.BBAND_20_2': 'Bollinger Band %B (20,2)',
  'algo.bl.TIN_HIEU_KY_THUAT.MA_ENVELOPES_20_25':
    'Moving Average Envelopes (20,2.5) %E',
  'algo.bl.TIN_HIEU_KY_THUAT.P_PER_SMA10': 'Giá so với SMA (10) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.P_PER_EMA10': 'Giá so với EMA (10) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.P_PER_DEMA10': 'Giá so với DEMA (10) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.P_PER_WMA10': 'Giá so với WMA (10) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.SMA5_PER_SMA20': 'SMA (5) so với SMA (20) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.EMA5_PER_EMA20': 'EMA (5) so với EMA (20) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.DEMA5_PER_DEMA20': 'DEMA (5) so với DEMA (20) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.WMA5_PER_WMA20': 'WMA (5) so với WMA (20) (%)',

  'algo.signal.1133': 'ADX(14)',
  'algo.signal.1134': 'Bollinger Band(20,2)',
  'algo.signal.1135': 'CCI(14)',
  'algo.signal.1137': 'Price vs. EMA(20)',
  'algo.signal.1138': 'Price vs. EMA(50)',
  'algo.signal.1139': 'Price vs. SMA(20)',
  'algo.signal.1140': 'Price vs. SMA(50)',
  'algo.signal.1141': 'Price vs. 3-month High or Low',
  'algo.signal.1142': 'Price vs. 6-month High or Low',
  'algo.signal.1143': 'MACD(12,26,9)',
  'algo.signal.1144': 'MFI(14)',
  'algo.signal.1145': 'RSI(14)',
  'algo.signal.1146': 'StochRSI(14)',
  'algo.signal.1147': 'Stochastic(9,6,6)',
  'algo.signal.1148': 'William %R(14)',
  'algo.signal.1149': 'EMA(20) vs. EMA(50)',
  'algo.signal.1150': 'EMA(5) vs. EMA(20)',
  'algo.signal.1151': 'SMA(20) vs. SMA(50)',
  'algo.signal.1152': 'SMA(5) vs. SMA(20)',

  'algo.tooltip.1133':
    'Buy signal when ADX > 20 and +DI crosses -DI\nSell signal when ADX < 20 and -DI crosses +DI',
  'algo.tooltip.1134':
    'Buy signal when Low Band crosses Price\nSell signal when Price crosses Up Band',
  'algo.tooltip.1135':
    'Buy signal when CCI crosses -200\nSell signal when 200 crosses CCI',
  'algo.tooltip.1137':
    'Buy signal when Price crosses EMA(20)\nSell signal when EMA(20) crosses Price',
  'algo.tooltip.1138':
    'Buy signal when Price crosses EMA(50)\nSell signal when EMA(50) crosses Price',
  'algo.tooltip.1139':
    'Buy signal when Price crosses SMA(20)\nSell signal when SMA(20) crosses Price',
  'algo.tooltip.1140':
    'Buy signal when Price crosses SMA(50)\nSell signal when SMA(50) crosses Price',
  'algo.tooltip.1141':
    'Buy signal when Price crosses 3-month high\nSell signal when 3-month high crosses Price',
  'algo.tooltip.1142':
    'Buy signal when Price crosses 6-month high\nSell signal when 6-month high crosses Price',
  'algo.tooltip.1143':
    'Buy signal when MACD crosses 0\nSell signal when 0 crosses MACD',
  'algo.tooltip.1144': 'Buy signal when MFI < 10\nSell signal when MFI > 90',
  'algo.tooltip.1145':
    'Buy signal when RSI(14) crosses 30\nSell signal when 70 crosses RSI(14)',
  'algo.tooltip.1146':
    'Buy signal when 10 crosses StochRSI(14)\nSell signal when StochRSI(14) crosses 90',
  'algo.tooltip.1147':
    'Buy signal when Stochastic crosses 20\nSell signal when 80 crosses Stochastic',
  'algo.tooltip.1148':
    'Buy signal when -80 crosses %R\nSell signal when %R crosses -20',
  'algo.tooltip.1149':
    'Buy signal when EMA(20) crosses EMA(50)\nSell signal when EMA(50) crosses EMA(20)',
  'algo.tooltip.1150':
    'Buy signal when EMA(5) crosses EMA(20)\nSell signal when EMA(20) crosses EMA(5)',
  'algo.tooltip.1151':
    'Buy signal when SMA(20) crosses SMA(50)\nSell signal when SMA(50) crosses SMA(20)',
  'algo.tooltip.1152':
    'Buy signal when SMA(5) crosses SMA(20)\bSell signal when SMA(20) crosses SMA(5)',

  'algo.tooltip.DVD_PAID_RATE':
    'Calculated as DPS for the last 4 quarters divided by EPS for the last 4 quarters. \nDPS is the dividend per share.\nEPS is net earnings per share',
  'algo.tooltip.DVD_PER_P':
    'Calculated as DPS for the last 4 quarters divided by the latest Closing Price.\nDPS is the dividend per share.',
  'algo.tooltip.DVD_1Y': 'Total cash dividend per share in the last 4 quarters',
  'algo.tooltip.EPS':
    'Calculated as Total interest of the parent company in the last 4 quarters divided by the Average number of shares outstanding for the 4 corresponding quarters.',
  'algo.tooltip.PE':
    'Calculated by Market Capitalization divided by the total interests of the parent company for the last 4 quarters.',
  'algo.tooltip.PB':
    'Calculated by Market capitalization divided by  Book Value of the most recent quarter',
  'algo.tooltip.PS':
    'Calculated by Market capitalization divided by Trailling four quarters Revenues',
  'algo.tooltip.EV_PER_EBIT':
    'Calculated by EV divided by EBIT.\nThe calculation of EV is shown in the metrics section of the Scale group.\nEBIT is calculated as (Net Revenue for the last 4 quarters – Cost of goods sold for the last 4 quarters – Expense for selling and general management of the last 4 quarters).\nThis indicator is not calculated for banking and insurance groups.',
  'algo.tooltip.EV_PER_EBITDA':
    'Calculated as EV divided by EBITDA.\nThe calculation of EV is shown in the metrics section of the Scale group.\nEBITDA is calculated as (Net revenue for the last 4 quarters – Cost of goods sold for the last 4 quarters – Expense for selling and general management of the last 4 quarters + Depreciation expense for the last 4 quarters).\nThis indicator is not calculated for banking and insurance groups.',
  'algo.tooltip.P_PER_FCF':
    'Calculated by Capitalization divided by FCF for the last 4 quarters.\nFCF = Cash flow from operating activities in the last 4 quarters - (Cash on purchases of fixed assets and other assets in the last 4 quarters - Proceeds from liquidation of fixed assets in the last 4 quarters) + Interest expense  in the last 4 quarters * (1 – CIT rate)\nCIT rate = Income taxes for the last 4 quarters / Profit before tax for the last 4 quarters\nThis indicator is not calculated for Banking and Insurance group',
  'algo.tooltip.TOTAL_VOL': 'Current-day trading volume',
  'algo.tooltip.AVG_VOL_5D':
    'Average trading volume of the last 5 trading days',
  'algo.tooltip.AVG_VOL_10D':
    'Average trading volume of the last 10 trading days',
  'algo.tooltip.AVG_VOL_20D':
    'Average trading volume of the last 20 trading days',
  'algo.tooltip.AVG_VOL_30D':
    'Average trading volume of the last 30 trading days',
  'algo.tooltip.AVG_VOL_60D':
    'Average trading volume of the last 60 trading days',
  'algo.tooltip.AVG_VOL_YTD':
    'Average trading volume from the beginning of the year to the present',
  'algo.tooltip.AVG_VOL_1Y': 'Average trading volume of the last 1 year',
  'algo.tooltip.TOTAL_VAL': 'Current-day trading value',
  'algo.tooltip.AVG_VAL_5D': 'Average trading value of the last 5 trading days',
  'algo.tooltip.AVG_VAL_10D':
    'Average trading value of the last 10 trading days',
  'algo.tooltip.AVG_VAL_20D':
    'Average trading value of the last 20 trading days',
  'algo.tooltip.AVG_VAL_30D':
    'Average trading value of the last 30 trading days',
  'algo.tooltip.AVG_VAL_60D':
    'Average trading value of the last 60 trading days',
  'algo.tooltip.AVG_VAL_YTD':
    'Average trading value from the beginning of the year to the present',
  'algo.tooltip.AVG_VAL_1Y': 'Average trading value of the last 1 year',
  'algo.tooltip.VOL_PER_5D': `Calculated as today's trading volume divided by the average of the previous 5 trading days`,
  'algo.tooltip.VOL_PER_10D': `Calculated as today's trading volume divided by the average of the previous 10 trading days`,
  'algo.tooltip.VOL_PER_20D': `Calculated as today's trading volume divided by the average of the previous 20 trading days`,
  'algo.tooltip.VOL_10D_VS_3M':
    'Calculated as the average trading volume of the last 10 trading days divided by the average trading volume of the last 3 months',
  'algo.tooltip.VAL_PER_5D': `Calculated as today's trading value divided by the average of the previous 5 trading days.`,
  'algo.tooltip.VAL_PER_10D': `Calculated as today's trading value divided by the average of the previous 10 trading days.`,
  'algo.tooltip.VAL_PER_20D': `Calculated as today's trading value divided by the average of the previous 20 trading days.`,
  'algo.tooltip.P_PER_20D': `Calculated as today's closing price divided by the average of the previous 20 trading days' closing prices.\nThe adjusted price is used for the calculation`,
  'algo.tooltip.P_PER_50D': `Calculated as today's closing price divided by the average of the previous 50 trading days' closing prices.\nThe adjusted price is used for the calculation`,
  'algo.tooltip.P_PER_130D': `Calculated as today's closing price divided by the average of the previous 130 trading days' closing prices.\nThe adjusted price is used for the calculation`,
  'algo.tooltip.P_PER_200D': `Calculated as today's closing price divided by the average of the previous 200 trading days' closing prices.\nThe adjusted price is used for the calculation`,
  'algo.tooltip.P_CHANGE_1W': `Calculated as (Today's closing price / Last 6 trading days' closing price - 1)\nThe adjusted price is used for the calculation.`,
  'algo.tooltip.P_CHANGE_1M': `Calculated as (Today's closing price / This day's closing price last calendar month - 1).\nThe adjusted price is used for the calculation.\nIn case this day of the previous month is a holiday/holiday, the closing price of the previous most recent trading day will be taken.`,
  'algo.tooltip.P_CHANGE_3M': `Calculated as (Today's closing price / This day's closing price 3 calendar months ago - 1).\nThe adjusted price is used for the calculation.\nIn case this date last month is a holiday/holiday, the closing price of the previous most recent trading day will be taken`,
  'algo.tooltip.P_CHANGE_6M': `Calculated as (Today's Closing Price / This day's closing price 6 calendar months ago - 1).\nThe adjusted price is used for the calculation.\nIn case this day of the previous month is a holiday/holiday, the closing price of the previous most recent trading day will be taken.`,
  'algo.tooltip.P_CHANGE_1Y': `Calculated as (Today's closing price / This day's closing price last calendar year - 1).\nThe adjusted price is used for the calculation.\nIn case this date last month is a holiday/holiday, the closing price of the previous most recent trading day will be taken.`,
  'algo.tooltip.P_PER_MAX_52W': `Calculated as (Today's Closing Price / 52 Week High).\nThe adjusted price is used for the calculation`,
  'algo.tooltip.P_PER_MIN_52W': `Calculated as (Today's Closing Price / 52 Week Low).\nThe adjusted price is used for the calculation`,
  'algo.tooltip.BETA30D': `Beta 30 days = Covariance(Ri,Rm) / Variance(Rm)\nwhere Ri is the 1-day stock price change and Rm is the 1-day VN-Index change.\nThe adjusted price is used for the calculation and the calculation period is 30 trading days`,
  'algo.tooltip.BETA60D': `Beta 30 days = Covariance(Ri,Rm) / Variance(Rm)\nwhere Ri is the 1-day stock price change and Rm is the 1-day VN-Index change.\nThe adjusted price is used for the calculation and the calculation period is 60 trading days`,
  'algo.tooltip.BETA90D': `Beta 30 days = Covariance(Ri,Rm) / Variance(Rm)\nwhere Ri is the 1-day stock price change and Rm is the 1-day VN-Index change.\nThe adjusted price is used for the calculation and the calculation period is 90 trading days`,
  'algo.tooltip.RS1W':
    'Calculated as ((1 + 1-week stock price change) / (1 + 1-week VN-Index price change) - 1)',
  'algo.tooltip.RS1M':
    'Calculated as ((1 + 1-month stock price change) / (1 + 1-month VN-Index price change) - 1)',
  'algo.tooltip.RS3M':
    'Calculated as ((1 + 3-month stock price change) / (1 + 3-month VN-Index price change) - 1)',
  'algo.tooltip.RS6M':
    'Calculated as ((1 + 6-month stock price change) / (1 + 6-month VN-Index price change) - 1)',
  'algo.tooltip.RS1Y':
    'Calculated as ((1 + 1-year change in stock price) / (1 + 1-year change in VN-Index price ) - 1)',
  'algo.tooltip.STD_P_1Y':
    'An indicator that measures the dispersion of daily stock price changes within 1 year.',
  'algo.tooltip.INVENTORY_TURN':
    'Calculated by Cost of Goods Sold for the last 4 quarters divided by the Average of Inventory for the last 4 quarters.\nThis indicator is not calculated for the Banking and Insurance group',
  'algo.tooltip.INVENTORY_DAYS':
    'Calculated as 365 divided by the Inventory Turnover Ratio.\nThis indicator is not calculated for the Banking and Insurance group.',
  'algo.tooltip.REC_TURN':
    'Calculated as Net Revenue of the last 4 quarters divided by the average of Receivables of the last 4 quarters.\nThis indicator is not calculated for the Banking and Insurance group.',
  'algo.tooltip.REC_DAYS':
    'Calculated as 365 divided by the Receivables Turnover Ratio.\nThis indicator is not calculated for the Banking and Insurance group.',
  'algo.tooltip.PAY_TURN':
    'Calculated as Purchases divided by Average Payables.\nPurchases = Ending Inventory - Beginning Inventory + Cost of Goods Sold.\nIndicators are taken for the last 4 quarters.\nThis indicator is not calculated for Banking and Insurance group.',
  'algo.tooltip.PAY_DAYS':
    'Calculated as 365 divided by the Payables Turnover Ratio.\nThis indicator is not calculated for the Banking and Insurance group.',
  'algo.tooltip.CAPITAL_TURN':
    'Calculated by Net Sales divided by Average Working Capital.\nWorking capital = Current assets - Current liabilities.\nIndicators are taken for the last 4 quarters.\nThis indicator is not calculated for the Banking and Insurance group.',
  'algo.tooltip.FIXED_ASSETS_TURN':
    'Calculated as Net Revenue for the last 4 quarters divided by the average of Fixed assets for the last 4 quarters.',
  'algo.tooltip.ASSETS_TURN':
    'Calculated by Net Revenue of the last 4 quarters divided by the average of Total Assets of the last 4 quarters.',
  'algo.tooltip.ROA':
    'Calculated by Net Income of the last 4 quarters divided by the average of Total assets of the last 4 quarters.',
  'algo.tooltip.ROE': `Calculated by Net Income for the last 4 quarters divided by the average Shareholder's Equity of the last 4 quarters.`,
  'algo.tooltip.GR_MARGIN':
    'Calculated as Gross Profit for the last 4 quarters divided by Net Revenues for the last 4 quarters.',
  'algo.tooltip.OPERATING_MARGIN':
    'Calculated as Opreating profit divided by Net Revenue for the last 4 quarters.',
  'algo.tooltip.BF_TAX_MARGIN':
    'Calculated by Profit before tax for the last 4 quarters divided by Net revenue for the last 4 quarters.',
  'algo.tooltip.NET_MARGIN':
    'Calculated by Net Income for the last 4 quarters divided by Net revenue for the last 4 quarters.',
  'algo.tooltip.ROIC':
    'Calculated as EBIT for the last 4 quarters * (1 – CIT rate) / (Average of Total Assets for the last 4 quarters - Average of Current Liabilities for the last 4 quarters)\nEBIT for the last 4 quarters = Net Revenue for the last 4 quarters – Cost of goods sold for the last 4 quarters – Selling and general management expenses for the last 4 quarters.\nCIT rate = CIT rate for the last 4 quarters / Profit before tax for the last 4 quarters.\nThis indicator is not calculated for Banking and Insurance group.',
  'algo.tooltip.ROCE':
    'Calculated as EBIT for the last 4 quarters * (1 – CIT rate) / (Average of Total Assets for the last 4 quarters - Average of Current Liabilities for the last 4 quarters)\nEBIT for the last 4 quarters = Net sales for the last 4 quarters – Cost of goods sold for the last 4 quarters – Selling and general management expenses for the last 4 quarters.\nCIT rate = CIT rate for the last 4 quarters / Profit before tax for the last 4 quarters.\nThis indicator is not calculated for Banking and Insurance group.',
  'algo.tooltip.DEBT_PER_ASSETS':
    'Calculated by Total Debt divided by Total Assets.\nTotal debt = Interest-bearing short-term debt + Interest-bearing long-term debt.\nIndicators are taken according to the most recent quarter.\nThis indicator is not calculated for the Banking group.',
  'algo.tooltip.DEBT_PER_CAPITAL':
    'Calculated by Total Debt divided by Total Equity.\nTotal debt = Interest-bearing short-term debt + Interest-bearing long-term debt.\nTotal capital = Equity + Total debt.\nIndicators are taken according to the most recent quarter.',
  'algo.tooltip.DEBT_PER_EQUITY':
    'Calculated as Total Debt divided by Equity.\nTotal debt = Interest-bearing short-term debt + Interest-bearing long-term debt.\n\nIndicators are taken according to the most recent quarter.\nThis indicator is not calculated for the Banking group.',
  'algo.tooltip.LEVERAGE':
    'Calculated as Total Assets for the latest quarter divided by Equity for the latest quarter.',
  'algo.tooltip.INT_COVERAGE':
    'Calculated by EBIT for the last 4 quarters divided by Interest Expense for the last 4 quarters.\nEBIT for the last 4 quarters = Net sales for the last 4 quarters – Cost of goods sold for the last 4 quarters – SG&A expenses for the last 4 quarters\nThis indicator is not calculated for the Banking and Insurance group.',
  'algo.tooltip.CASH_PER_ASSETS':
    'Calculated as Cash and Cash equivalents for the latest quarter divided by Total Assets for the latest quarter.\nThis indicator is not calculated for the Banking group.',
  'algo.tooltip.FCF_PER_LT_DEBT': `Calculated as FCF of the last 4 quarters divided by the latest quarter's long-term debt.\nFCF = Cash flow from operating activities in the last 4 quarters - (Cash on purchases of fixed assets and other assets in the last 4 quarters - Proceeds from liquidation of fixed assets in the last 4 quarters) + Interest expense  in the last 4 quarters * (1 – CIT rate)\nCIT rate = CIT rate for the last 4 quarters / Profit before tax for the last 4 quarters\nThis indicator is not calculated for the Banking and Insurance group`,
  'algo.tooltip.NET_DEBT_PER_EQUITY':
    'Calculated as Net Debt divided by Equity.\nNet debt = Interest-bearing short-term debt + Interest-bearing long-term debt - Cash and cash equivalents - short-term investments.\nIndicators are taken according to the most recent quarter.\nThis indicator is not calculated for Banking and Insurance group',
  'algo.tooltip.NET_DEBT_PER_TANGIBLE_EQUITY':
    'Calculated as Net Debt divided by Tangible Equity.\nNet debt = Interest-bearing short-term debt + Interest-bearing long-term debt - Cash and cash equivalents - Short-term investments.\nTangible equity = Equity - Intangible fixed assets.\nIndicators are taken according to the most recent quarter.\nThis indicator is not calculated for the Banking and Insurance group.',
  'algo.tooltip.LT_DEBT_PER_ASSETS': `Calculated as the latest quarter's Long-term debt divided by the latest quarter's Total assets.\nThis indicator is not calculated for the Banking group.`,
  'algo.tooltip.TANGIBLE_ASSETS_PER_EQUITY':
    'Calculated by Tangible Assets divided by Equity.\nTangible assets = Total assets - Intangible fixed assets.\nIndicators are taken according to the most recent quarter.',
  'algo.tooltip.NET_DEBT_PER_MC':
    'Calculated as Net Debt divided by Market Capitalization.\nNet debt = Interest-bearing short-term debt + Interest-bearing long-term debt - Cash and cash equivalents - Short-term investments.\nIndicators are taken according to the most recent quarter.\nThis indicator is not calculated for the Banking and Insurance group.',
  'algo.tooltip.NET_DEBT_PER_TANGIBLE_ASSETS':
    'Calculated as Net Debt divided by Tangible Assets\nNet debt = Interest-bearing short-term debt + Interest-bearing long-term debt - Cash and cash equivalents - Short-term investments.\nIndicators are taken according to the most recent quarter.\nThis indicator is not calculated for the Banking and Insurance group.',
  'algo.tooltip.CURR_RATIO':
    'Calculated as Current Assets of the latest quarter divided by Current Liabilities of the latest quarter.',
  'algo.tooltip.QUICK_RATIO':
    'Calculated by ((Cash and cash equivalents + short-term investments + Receivables) / Current liabilities). Indicators are taken in the most recent quarter.',
  'algo.tooltip.CASH_RATIO':
    'Calculated by ((Cash and cash equivalents + short-term investments) / Current liabilities). Indicators are taken in the most recent quarter.',
  'algo.tooltip.CASH_TURN':
    'Calculated as (Number of days receivable for the last 4 quarters + Days of inventory for the last 4 quarters - Days of payable for the last 4 quarters)',
  'algo.tooltip.F_BUY_VALUE': 'Value bought by foreign investors today',
  'algo.tooltip.F_SELL_VALUE': 'Value sold by foreign investors today',
  'algo.tooltip.F_NET_BUY_VALUE':
    'Calculated by the buy value minus the sell value of foreign investors today.',
  'algo.tooltip.F_BUY_VAL_PER_5D':
    'Calculated as the buy value today divided by the average buy value of foreign investors in the previous 5 trading days.',
  'algo.tooltip.F_BUY_VAL_PER_10D':
    'Calculated as the buy value today divided by the average buy value of foreign investors in the previous 10 trading days.',
  'algo.tooltip.F_BUY_VAL_PER_20D':
    'Calculated as the buy value today divided by the average buy value of foreign investors in the previous 20 trading days.',
  'algo.tooltip.F_SELL_VAL_PER_5D':
    'Calculated as the sold value today divided by the average sold value of foreign investors in the previous 5 trading days.',
  'algo.tooltip.F_SELL_VAL_PER_10D':
    'Calculated as the sold value today divided by the average sold value of foreign investors in the previous 10 trading days.',
  'algo.tooltip.F_SELL_VAL_PER_20D':
    'Calculated as the sold value today divided by the average sold value of foreign investors in the previous 20 trading days.',
  'algo.tooltip.F_NET_BUY_VOLUME':
    'Calculated by the buy volume minus the sell volume of foreign investors today.',
  'algo.tooltip.AVG_F_NET_BUY_VOL_5D':
    'Calculated as average buying volume minus average selling volume of foreign investors in the last 5 trading days',
  'algo.tooltip.AVG_F_NET_BUY_VOL_10D':
    'Calculated as average buying volume minus average selling volume of foreign investors in the last 10 trading days',
  'algo.tooltip.AVG_F_NET_BUY_VOL_20D':
    'Calculated as average buying volume minus average selling volume of foreign investors in the last 20 trading days',
  'algo.tooltip.AVG_F_NET_BUY_VOL_30D':
    'Calculated as average buying volume minus average selling volume of foreign investors in the last 30 trading days',
  'algo.tooltip.AVG_F_NET_BUY_VOL_60D':
    'Calculated as average buying volume minus average selling volume of foreign investors in the last 60 trading days',
  'algo.tooltip.AVG_F_NET_BUY_VOL_YTD':
    'Calculated as average buying volume minus average selling volume of foreign investors from the begining of this year',
  'algo.tooltip.AVG_F_NET_BUY_VOL_1Y':
    'Calculated as average buying volume minus average selling volume of foreign investors in the last 1 year',
  'algo.tooltip.AVG_F_NET_BUY_5D':
    'Calculated as the average buying value minus the averageselling value of foreign investors in the last 5 trading days.',
  'algo.tooltip.AVG_F_NET_BUY_10D':
    'Calculated as the average buying value minus the averageselling value of foreign investors in the last 10 trading days.',
  'algo.tooltip.AVG_F_NET_BUY_20D':
    'Calculated as the average buying value minus the averageselling value of foreign investors in the last 20 trading days.',
  'algo.tooltip.AVG_F_NET_BUY_30D':
    'Calculated as the average buying value minus the averageselling value of foreign investors in the last 30 trading days.',
  'algo.tooltip.AVG_F_NET_BUY_60D':
    'Calculated as the average buying value minus the averageselling value of foreign investors in the last 60 trading days.',
  'algo.tooltip.AVG_F_NET_BUY_YTD':
    'Calculated as the average buying value minus the averageselling value of foreign investors from the beginning of the year',
  'algo.tooltip.AVG_F_NET_BUY_1Y':
    'Calculated as the average buying value minus the averageselling value of foreign investors in the last 1 year',
  'algo.tooltip.MC':
    'Calculated as the number of shares outstanding multiplied by the share price at the time of calculation.\nTwo factors are the number of shares outstanding and the share price in the market data file provided by HOSE and HASTC.',
  'algo.tooltip.EV':
    'EV = Market Capitalization + Interest-bearing short-term debt + Interest-bearing long-term debt - Cash and cash equivalents - Short-term investments\nFor regular companies:\n- Interest-bearing short-term debt = Short-term loan + Government bond repurchase transaction\n- Interest-bearing long-term debt = Long-term loans + convertible bonds\nFor securities companies:\n- Short-term debt bearing interest = Borrowing and leasing of short-term financial assets + Borrowing of short-term financial assets + Short-term convertible bonds + Short-term issued bonds + Loans to support payment + Purchase transactions resale of government bonds\n- Long-term interest-bearing debt = Long-term borrowings and leases of financial assets + Long-term borrowings of financial assets + Long-term convertible bonds + Long-term issued bonds\nEVs are not calculated for companies belonging to the Banking and Insurance industry.',
  'algo.tooltip.M_SCORE': `Used to assess a company's ability to manipulate profits.\nM-Score greater than -1.78 represents businesses with a high risk of profit manipulation.\nM-Score is not calculated for Banking and Insurance.`,
  'algo.tooltip.F_SCORE':
    'Used to score the financial health of a business on a scale of 0 to 9.\nThe higher the F-Score, the better the financial health of the business.',
  'algo.tooltip.Z_SCORE':
    'Used to assess the bankruptcy risk of a business.\nZ >= 2.99: Safe business\n1.8 < Z < 2.99: Need to be careful with businesses\nZ <= 1.8: Enterprise is at risk of crisis\nThis indicator is not calculated for Banking and Insurance group.',
  'algo.tooltip.C_SCORE':
    'Used to assess the risk of a business manipulating financial statements.\nThe higher the C-Score, the higher the risk that the company has to mess up the financial statements',
  'algo.tooltip.MAGIC_SCORE':
    'Exclude the ICB2-Banking and ICB2-Insurance industries\nCalculate the following metrics:\n- Earning yield = (EBIT last 4 quarters) / EV latest quarter\n- ROCE = (EBIT for the last 4 quarters) / (Average of Total Assets for the last 4 quarters - Average of Current Liabilities for the last 4 quarters)\nEarning yield ranking, the company with the highest earning yield ranked 1\nROCE rating, the company with the highest ROCE is ranked 1\nTotal Rank = Earning yield Rank + ROCE Rank\nRating "Total Rating", in percentile, the Company with the lowest Total Rating receives the value 100',
  'algo.tooltip.NET_INC_GROWTH':
    'Calculated by (Total Net Income of the last 4 quarters / Total Net Income of the last 4 quarters of the same period - 1).\nExample: Net Income Q4.2018-Q3.2019 / Net Income Q4.2017-Q3.2018 - 1',
  'algo.tooltip.EPS_GROWTH':
    'Calculated as (last 4 quarter EPS / previous 4 quarter EPS - 1).\nExample: EPS Q4.2018-Q3.2019 / EPS Q4.2017-Q3.2018 - 1',
  'algo.tooltip.REV_GROWTH_1Y':
    'Calculated as (Total revenue of the last 4 quarters / Total revenue of 4 previous quarters - 1).\nExample: Revenue of Q4.2018-Q3.2019 / Revenue of Q4.2017-Q3.2018 - 1',
  'algo.tooltip.DVD_GROWTH':
    'Calculated as (DPS of the last 4 quarters / DPS of 4 previous quarters - 1).\nExample: Revenue of Q4.2018-Q3.2019 / Revenue of Q4.2017-Q3.2018 - 1',
  'algo.tooltip.OPERATING_INC_GROWTH':
    'Calculated as (Operating profit for the last 4 quarters / Operating profit for the last 4 quarters of the same period - 1).\nExample: Operating profit Q4.2018-Q3.2019 / Operating profit Q4.2017-Q3.2018 - 1',
  'algo.tooltip.GR_PROFIT_GROWTH':
    'Calculated as (Gross profit for the last 4 quarters / Gross profit for the last 4 quarters of the same period - 1).\nExample: Gross profit Q4.2018-Q3.2019 / Gross profit Q4.2017-Q3.2018 - 1',
  'algo.tooltip.NET_INC_GROWTH1':
    'Calculated as (Net Income for the last 4 quarters / Net Income for the last 4 quarters of the same period - 1).\nExample: Net Income Q4.2018-Q3.2019 / Net Income Q4.2017-Q3.2018 - 1',
  'algo.tooltip.REV_GROWTH1':
    'Calculated as (Recent quarter Revenue / Quarterly Revenue of the same period last year - 1).\nExample: Q2.2019 revenue / Q2.2018 revenue - 1',
  'algo.tooltip.OPERATING_INC_GROWTH1':
    'Calculated by (Operating profit of the latest quarter / Operating profit of the same quarter of the same period last year - 1).\nExample: Operating profit in Q2.2019 / Operating profit in Q2.2018 - 1',
  'algo.tooltip.GR_PROFIT_GROWTH1': `Calculated by (Recent quarter Gross Profit / Last year's same quarter Gross Profit - 1).\nExample: Gross profit Q2.2019 / Gross profit Q2.2018 - 1`,
  'algo.tooltip.RSI_14':
    'Relative Strength Index (RSI) is a momentum indicator that measures the speed and variability of price movements. RSI fluctuates between 0 and 100. RSI is considered overbought when greater than 70 and oversold when less than 30',
  'algo.tooltip.STOCHASTIC_14_3_3':
    'Stochastic Oscillator (STOCH) là chỉ báo động lượng cho biết vị trí của giá đóng cửa so với khoảng giá cao-giá thấp qua một giai đoạn. STOCH có thể được sử dụng để dự báo sự đảo chiều và xác định mức quá mua, quá bán. Giá trị được đưa vào bộ lọc là Full %K.',
  'algo.tooltip.ADI_14':
    'Average Directional Index (ADX) is an indicator used to determine trend and trend strength. ADX greater than 20 indicates that a price trend is occurring',
  'algo.tooltip.STOCHASTIC_RSI_14':
    'The Stochastic RSI (STOCHRSI) is an oscillator that measures the RSI level relative to the high-low range over a period. STOCHRSI applies the Stochastic formula to the RSI value instead of the stock price, making it an indicator of the indicator. STOCHRSI fluctuates between 0 and 1, considered overbought when the value is greater than 0.8 and oversold when the value is less than 0.2.',
  'algo.tooltip.ATR_14':
    'Average True Range (ATR) is an indicator that measures the volatility of stocks, solving the problem of gaping stocks.',
  'algo.tooltip.WILLIAMR_14':
    'William %R is a momentum indicator that reflects the position of the closing price relative to the highest price over a period of time. This indicator oscillates between -100 and 0, with the range from 0 to -20 being considered overbought and the range from -100 to -80 being considered oversold.',
  'algo.tooltip.MACD_12_26_9':
    'Moving Average Convergence / Divergence Oscillator (MACD) is one of the simplest and most effective momentum indicators. The MACD turns two trend indicators (two moving averages) into one momentum indicator by subtracting the long moving average from the short moving average. Therefore, the MACD is both trend-following and oscillating. MACD greater than 0 is considered uptrend and MACD less than 0 is considered downtrend.',
  'algo.tooltip.MFI_14':
    'The Money Flow Index (MFI) is an oscillator that uses both price and volume to measure buying and selling pressure. MFI starts by calculating the typical price for each period. Money flow is positive when the typical price increases (buying pressure) and negative when the typical price decreases (selling pressure). The ratio between positive and negative money flow is then fed into the RSI formula to create an oscillation between 0 and 100. The MFI is used to identify reversals using various other indicators.',
  'algo.tooltip.BBAND_20_2': `Bollinger Band %B determines the position of a security's price relative to the upper and lower bands of the Bollinger Band. There are 3 basic positions:\n- %B is less than 0 when the price is less than the lower Band.\n- %B is between 0 and 1 when the price is between the upper and lower bands.\n- %B is greater than 1 when the price is greater than the upper Band.\nSecurities are considered overbought when %B is greater than 1 and oversold when %B is less than 1.`,
  'algo.tooltip.MA_ENVELOPES_20_25': `Moving Average Envelopes are percentage-based envelopes placed above and below a simple moving average. Each envelope is placed the same percentage greater or less than the moving average. This creates parallel lines. moving and following price movements.Moving Average Envelopes can be used to identify price trends as well as overbought and oversold levels.\nMoving Average Envelopes %E determines the position of a security's price relative to the Upper and Lower Bands of the Moving Average Envelopes. There are 3 basic positions:\n- %E is less than 0 when the price is less than the lower Band.\n- %E is between 0 and 1 when the price is between the upper and lower bands.\n- %E is greater than 1 when the price is greater than the upper Band.\nSecurities are considered overbought when %E is greater than 1 and oversold when %E is less than 1.`,
  'algo.tooltip.P_PER_SMA10':
    'Calculated as dividing the Current Price by the SMA of the previous 10 trading days.\n- Value greater than 1 when price is greater than SMA (10)\n- Value equals 1 when Price equals SMA (10)\n- Value less than 1 when Price is less than SMA (10)',
  'algo.tooltip.P_PER_EMA10':
    'Calculated by dividing the Current Price by the EMA of the previous 10 trading days.\n- Value greater than 1 when price is greater than EMA (10)\n- Value equals 1 when Price equals EMA (10)\n- Value less than 1 when Price is less than EMA (10)',
  'algo.tooltip.P_PER_DEMA10':
    'Calculated as dividing the Current Price by the DEMA of the previous 10 trading days.\n- Value greater than 1 when price is greater than DEMA (10)\n- Value equals 1 when Price equals DEMA (10)\n- Value less than 1 when Price is less than DEMA (10)',
  'algo.tooltip.P_PER_WMA10':
    'Calculated as dividing the Current Price by the WMA of the previous 10 trading days.\n- Value greater than 1 when price is greater than WMA (10)\n- Value equals 1 when Price equals WMA (10)\n- Value less than 1 when Price is less than WMA (10)',
  'algo.tooltip.SMA5_PER_SMA20':
    'Calculated by dividing the previous 5 trading day SMA by the previous 20 trading day SMA.\n- Value greater than 1 when SMA (5) is greater than SMA (20)\n- Value equals 1 when SMA (5) equals SMA (20)\n- Value less than 1 when SMA (5) is less than SMA (20)',
  'algo.tooltip.EMA5_PER_EMA20':
    'Calculated by dividing the previous 5 trading day EMA by the previous 20 trading day EMA.\n- Value greater than 1 when EMA (5) is greater than EMA (20)\n- Value equals 1 when EMA (5) is equal to EMA (20)\n- Value less than 1 when EMA (5) is less than EMA (20)',
  'algo.tooltip.DEMA5_PER_DEMA20':
    'Calculated by dividing the previous 5 trading day DEMA by the previous 20 trading day DEMA.\n- Value greater than 1 when DEMA (5) is greater than DEMA (20)\n- The value equals 1 when DEMA (5) is equal to DEMA (20)\n- Value less than 1 when DEMA (5) is less than DEMA (20)',
  'algo.tooltip.WMA5_PER_WMA20':
    'Calculated by dividing the previous 5 trading day WMA by the previous 20 trading day WMA.\n- Value greater than 1 when WMA (5) is greater than WMA (20)\n- Value equals 1 when WMA (5) is equal to WMA (20)\n- Value less than 1 when WMA (5) is less than WMA (20)',
};
